import { CountryPreferenceProduct } from '@/api/Clients/Types/CountryPreferenceProduct'
import { Checkbox } from '@/components/ui/checkbox'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { CheckboxFilterCell } from 'components/Filter/FilterCell'

import { CountryFilterCell, ProductFilterCell, TickmillCompanyFilterCell } from './CountriesFilters'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const countriesProducts: GridColumn[] = [
  {
    title: 'Tickmill Entity',
    field: 'tickmillCompany.name',
    filterCell: TickmillCompanyFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.tickmillCompany?.name) {
        return <td />
      }

      return <td>{props.dataItem.tickmillCompany.name}</td>
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Country',
    field: 'country.name',
    filterCell: CountryFilterCell,
    show: true,
    sortable: false,
  },
  {
    title: 'Product',
    filterCell: ProductFilterCell,
    field: 'products',
    cell: (props: GridCellProps): JSX.Element => {
      if (!props?.dataItem?.products?.length) {
        return <td />
      }

      return (
        <td>
          {props.dataItem.products.map((p: CountryPreferenceProduct) => (
            <p key={p.id}>
              {p.name}
              {!!p.subProducts?.length && (
                <span>
                  {' '}
                  {'>'} ({p.subProducts.map((subProduct) => subProduct.name).join(', ')})
                </span>
              )}
            </p>
          ))}
        </td>
      )
    },
    show: true,
    sortable: false,
  },
  {
    title: 'Hidden',
    field: 'isHidden',
    filterCell: CheckboxFilterCell,
    cell: (props: GridCellProps): JSX.Element => {
      return (
        <td align='center' style={{ textAlign: 'center' }}>
          <Checkbox checked={props.dataItem.isHidden} disabled />
        </td>
      )
    },
    show: true,
    sortable: false,
  },
]

export default countriesProducts
